import { Box } from '@mui/material'
import { useUI } from '../hooks/useUI'
import { useEffect, useState } from 'react'

interface LogoProps {
  src: string
  alt: string
  onClick?: () => void
}

const Logo = ({ src, alt, onClick }: LogoProps) => {
  const { darkMode } = useUI()
  const [isLogoLight, setIsLogoLight] = useState(false)

  useEffect(() => {
    // Detectar si el logo es claro analizando su imagen
    const detectLogoColor = () => {
      const img = new Image()
      img.src = src
      img.crossOrigin = 'Anonymous' // Necesario para imágenes de otros dominios

      img.onload = () => {
        const canvas = document.createElement('canvas')
        const context = canvas.getContext('2d')
        if (!context) return

        canvas.width = img.width
        canvas.height = img.height
        context.drawImage(img, 0, 0)

        // Analizar los píxeles de la imagen
        const imageData = context.getImageData(0, 0, canvas.width, canvas.height)
        const data = imageData.data

        let brightness = 0
        // Calcular el brillo promedio
        for (let i = 0; i < data.length; i += 4) {
          brightness += (data[i] + data[i + 1] + data[i + 2]) / 3
        }
        brightness = brightness / (data.length / 4)

        // Si el brillo promedio es alto, consideramos que es un logo claro
        setIsLogoLight(brightness > 127)
      }
    }

    detectLogoColor()
  }, [src])

  return (
    <Box
      component="div"
      onClick={onClick}
      className={`
        relative cursor-pointer transition-all duration-200
        ${darkMode && isLogoLight ? 'logo-dark-mode' : ''}
        ${!darkMode && !isLogoLight ? 'logo-light-mode' : ''}
      `}
      sx={{
        '& img': {
          height: { xs: '40px', sm: '50px' },
          width: 'auto',
          transition: 'filter 0.2s ease-in-out'
        },
        '&.logo-dark-mode img': {
          filter: 'drop-shadow(0 0 1px rgba(255,255,255,0.5))'
        },
        '&.logo-light-mode img': {
          filter: 'drop-shadow(0 0 1px rgba(0,0,0,0.5))'
        },
        '&:hover img': {
          filter: 'brightness(1.1)'
        },
        // Fondo adaptativo para mejorar contraste si es necesario
        '&::before': {
          content: '""',
          position: 'absolute',
          inset: '-4px',
          borderRadius: '4px',
          opacity: 0.1,
          zIndex: -1,
          transition: 'opacity 0.2s ease-in-out',
          backgroundColor: darkMode ? 'white' : 'black'
        },
        '&:hover::before': {
          opacity: 0.15
        }
      }}
    >
      <img src={src} alt={alt} />
    </Box>
  )
}

export default Logo
